import {ILabelSet,PagingType} from "@backend/types"

import {labelSetActions} from "./service"

type LabelSetState = {
    labelSets?: PagingType<ILabelSet>
}

export function labelSetReducer(state: LabelSetState = {}, action) {
    switch (action.type) {
        case labelSetActions.actionTypes.LIST: {
            const labelSets: PagingType<ILabelSet> = action.payload

            return {labelSets}
        }
        case labelSetActions.actionTypes.CLEAR: {
            return {}
        }
        case labelSetActions.actionTypes.DELETE: {
            const labelSetId = action.payload
            const {labelSets: stateLabelSets} = state

            if (stateLabelSets) {
                stateLabelSets.docs = stateLabelSets.docs.filter(labelSet => labelSet._id !== labelSetId)
                stateLabelSets.totalDocs -= 1
            }

            return {labelSets: {...stateLabelSets}}
        }
        default:
            return state
    }
}

// type LabelState = {
//     parentLabels?: ILabel[],
//     labels?: PagingType<ILabel>
// }
//
// export function labelReducer(state: LabelState = {}, action) {
//
//     switch (action.type) {
//         case labelActions.actionTypes.PARENTS: {
//             const parentLabels: ILabel[] = action.payload
//             return {parentLabels}
//         }
//
//         case labelActions.actionTypes.LIST: {
//             const labels: PagingType<ILabel> = action.payload
//
//             return {labels}
//         }
//         case labelActions.actionTypes.DELETE: {
//             const gameId = action.payload
//             const {labels: stateLabels} = state
//
//             if (stateLabels) {
//                 stateLabels.docs = stateLabels.docs.filter(game => game._id !== gameId)
//                 stateLabels.totalDocs -= 1
//             }
//
//             return {labels: {...stateLabels}}
//
//         }
//
//         default:
//             return state
//     }
// }
